<!-- Badge de tiempo restante -->
<div *ngIf="expirationDate && !linkExpired" class="expiration-container">
    <div class="expiration-card" [ngClass]="{ 'critical': isCriticalTime, 'warning': isWarningTime }">
        <div class="expiration-header">
            <div class="icon-wrapper">
                <i class="pi pi-clock"></i>
            </div>
            <div class="expiration-content">
                <span class="expiration-label">Tiempo restante de acceso</span>
                <div class="expiration-timer">
                    <div class="time-block" *ngIf="remainingTime.hours > 0">
                        <span class="time-value">{{ remainingTime.hours | number:'2.0-0' }}</span>
                        <span class="time-unit">h</span>
                    </div>
                    <div class="time-separator" *ngIf="remainingTime.hours > 0">:</div>
                    <div class="time-block">
                        <span class="time-value">{{ remainingTime.minutes | number:'2.0-0' }}</span>
                        <span class="time-unit">m</span>
                    </div>
                    <div class="time-separator">:</div>
                    <div class="time-block">
                        <span class="time-value">{{ remainingTime.seconds | number:'2.0-0' }}</span>
                        <span class="time-unit">s</span>
                    </div>
                </div>
            </div>
        </div>
        
        <!-- Progress bar -->
        <div class="progress-wrapper">
            <p-progressBar 
                [value]="timePercentage" 
                [showValue]="false"
                [styleClass]="getProgressBarClass()">
            </p-progressBar>
        </div>

        <!-- Mensaje de advertencia cuando queda poco tiempo -->
        <div class="warning-message" *ngIf="isCriticalTime">
            <i class="pi pi-exclamation-triangle"></i>
            <span>¡Tiempo crítico! El link expirará pronto.</span>
        </div>
        <div class="warning-message mild" *ngIf="isWarningTime && !isCriticalTime">
            <i class="pi pi-info-circle"></i>
            <span>Quedan pocos minutos de acceso.</span>
        </div>
    </div>
</div>

<!-- Estado expirado -->
<div *ngIf="expirationDate && linkExpired" class="expired-container">
    <div class="flex align-items-start gap-3 p-3 border-round"
         style="background-color: var(--red-50); border: 1px solid var(--red-200);">
        <i class="pi pi-times-circle text-red-500 text-2xl mt-1"></i>
        <div>
            <p class="font-semibold text-red-700 m-0 mb-1">Enlace Expirado</p>
            <p class="m-0 text-sm text-color-secondary">
                El tiempo para acceder mediante este link ha finalizado.
                Por favor, solicita un nuevo enlace al administrador.
            </p>
        </div>
    </div>
</div>